import { useQuery } from '@tanstack/react-query';
import { networkClient } from './client';
import type { ApiEnvelope } from './types';
import { TEAM_CREATE_TOURNAMENT_CALENDAR_ID } from '@/pages/Teams/constants';

export interface BEGameweek {
  id: string;
  tournamentCalendarId: string | null;
  number: number;
  name: string | null;
  startsAt: string | null;
  endsAt: string | null;
  deadlineAt: string | null;
  status: string;
  assignedMatches: number;
  finalisedAt: string | null;
  budgetInitial: number;
  finalisedByAdminUserId: string | null;
  isDoubleGameweek: boolean;
  knockoutRound: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GameweeksResponseData {
  gameweeks: BEGameweek[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export type GameweeksResponse = ApiEnvelope<GameweeksResponseData>;

export interface FetchGameweeksParams {
  tournamentCalendarId?: string;
  page?: number;
  limit?: number;
  status?: string;
}

export const fetchGameweeks = (params?: FetchGameweeksParams): Promise<GameweeksResponse> => {
  return networkClient
    .get<GameweeksResponse>('/api/gameweeks', { params })
    .then(({ data }) => data);
};

export interface BECurrentGameweek {
  id: string;
  name: string;
  number: number;
  status: string;
  startsAt: string | null;
  deadlineAt: string | null;
  budgetInitial: number;
}

export interface CurrentGameweekResponseData {
  currentGameweek: BECurrentGameweek | null;
  nextGameweek: BECurrentGameweek | null;
}

export type CurrentGameweekResponse = ApiEnvelope<CurrentGameweekResponseData>;

export interface GetCurrentGameweekParams {
  tournamentCalendarId?: string;
}

export const fetchCurrentGameweek = (
  params?: GetCurrentGameweekParams
): Promise<CurrentGameweekResponse> => {
  return networkClient
    .get<CurrentGameweekResponse>('/api/gameweeks/current', { params })
    .then(({ data }) => data);
};

export const useGetGameweeksQuery = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ['gameweeks', TEAM_CREATE_TOURNAMENT_CALENDAR_ID, 'pending-transfer-blockers'],
    queryFn: async () => {
      const response = await fetchGameweeks({
        tournamentCalendarId: TEAM_CREATE_TOURNAMENT_CALENDAR_ID,
        limit: 100,
      });
      return response.data.gameweeks;
    },
    enabled,
    staleTime: 60 * 1000,
  });
};
